import React, { useState, useEffect } from 'react';
import { Users } from 'lucide-react';

const VisitorCounter = () => {
  const [count, setCount] = useState(1243); // Initial simulated count

  useEffect(() => {
    // Function to simulate real-time visitor fluctuations
    const interval = setInterval(() => {
      setCount(prev => {
        const change = Math.floor(Math.random() * 5) - 2; // Random change between -2 and +2
        const next = prev + change;
        // Keep count in a realistic range (e.g., 1200-1300)
        return next < 1200 ? 1205 : next > 1300 ? 1295 : next;
      });
    }, 5000); // Update every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="inline-flex items-center space-x-2 bg-white/40 backdrop-blur-md px-4 py-2 rounded-full border border-pink-100/50 shadow-sm transition-all hover:shadow-md hover:bg-white/60 group">
      <div className="relative">
        <Users className="w-4 h-4 text-[#FF6B9D] group-hover:scale-110 transition-transform" />
        <span className="absolute -top-1 -right-1 w-2 h-2 bg-green-500 rounded-full border-2 border-white animate-pulse" />
      </div>
      <div className="flex flex-col">
        <span className="text-[10px] uppercase tracking-wider text-gray-500 font-bold leading-none">Live Now</span>
        <span className="text-sm font-bold text-gray-900 leading-none tabular-nums">
          {count.toLocaleString()}
        </span>
      </div>
    </div>
  );
};

export default VisitorCounter;
